import './RadioScreen.vars.css'

const responsiveStyles = {
  top: 'var(--radio-screen-top)',
  right: 'var(--radio-screen-right)'
}

export default responsiveStyles
